import './ViewHeader.css';

export default function ViewHeader({children}) {
    return (
        <div className="view-header">
            {children}
        </div>
    );
}